import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loading-skeleton-list',
  templateUrl: './loading-skeleton-list.component.html',
  styleUrls: ['./loading-skeleton-list.component.scss'],
})
export class LoadingSkeletonListComponent implements OnInit {

  items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  constructor() { }

  ngOnInit() {}

}
